import * as api from "../utils/api"

interface FormattedOrderTrack {
  orderId: string
  x: number
  y: number
  width: number
  height: number
  keyPoints: { [key: string]: KeyPointType }
}

type KeyPointType = {
  x: number
  y: number
  confidence: number
}

interface FormattedOrderTracks {
  [key: string]: {
    [key: string]: FormattedOrderTrack
  }
}

interface FormattedOrderTracksResponse {
  formattedOrderTracks: FormattedOrderTracks | object
  orders: object
}

/**
 * Retrieves and formats order track data for frontend use
 * @param {string} cameraId The camera to retrieve order tracks for
 * @param {number} startTimeStamp The start timestamp for order track retrieval
 * @param {number} endTimeStamp The end timestamp for order track retrieval
 */
const getAndFormatOrderTracks = async (
  storeId: string,
  cameraId: string,
  startTimeStamp: number,
  endTimeStamp: number
): Promise<FormattedOrderTracksResponse> => {
  let formattedOrderTracks = {}
  let orders = {}

  // Retrieve orderTrack data
  let orderTracks = await api.getOrderTrack(storeId, cameraId, startTimeStamp, endTimeStamp)

  // Return if no orderTrack data
  if (orderTracks == null || Object.keys(orderTracks).length === 0) {
    return { formattedOrderTracks, orders }
  }

  if ("data" in orderTracks) {
    orderTracks = orderTracks["data"]
  }

  Object.keys(orderTracks).forEach((orderTrackTimestamp) => {
    const tracks = orderTracks[orderTrackTimestamp]
    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i]
      const orderId = track["track_id"]
      const x = track["tlx"]
      const y = track["tly"]
      const width = track["brx"] - x
      const height = track["bry"] - y
      const keyPoints = track["keypoints"]
      if (!formattedOrderTracks[orderTrackTimestamp]) formattedOrderTracks[orderTrackTimestamp] = {}
      // Create camera object for timestamp if doesn't exist
      if (!formattedOrderTracks[orderTrackTimestamp][cameraId]) {
        formattedOrderTracks[orderTrackTimestamp][cameraId] = []
      }
      // Create camera order list if doesn't exist
      if (orders[cameraId] == null) orders[cameraId] = []

      // Add order data to formattedOrderTracks
      formattedOrderTracks[orderTrackTimestamp][cameraId].push({
        orderId,
        x,
        y,
        width,
        height,
        keyPoints,
      })
      // Add order id to camera order list
      if (!orders[cameraId].includes(orderId)) orders[cameraId].push(orderId)
    }
  })
  return { formattedOrderTracks, orders }
}

/**
 * Retrieves and formats order track data for frontend use
 * @param {string} cameraId The camera to retrieve order tracks for
 * @param {number} startTimeStamp The start timestamp for order track retrieval
 * @param {number} endTimeStamp The end timestamp for order track retrieval
 */
const formatOrderTracksV2 = (
  cameraId: string,
  rawTracksList: any,
  orderTracks: any
): FormattedOrderTracksResponse => {
  let formattedOrderTracks = {}
  let orders = {}

  console.log("V2 cameraId = " + cameraId)
  console.log("V2 orderTracks = " + JSON.stringify(orderTracks))

  // Retrieve orderTrack data
  // const orderTracks = await api.getOrderTrack(cameraId, startTimeStamp, endTimeStamp)

  // Return if no orderTrack data
  if (orderTracks == null || orderTracks.length === 0) {
    return { formattedOrderTracks, orders }
  }

  Object.keys(rawTracksList).forEach((orderTrackTimestamp) => {
    const tracks = rawTracksList[orderTrackTimestamp]
    if (tracks) {
      tracks.forEach((track: any) => {
        const rawTrackId = track["rawtrack_id"]
        const orderTrackId = orderTracks[rawTrackId]
        if (orderTrackId) {
          const x = track["tlx"]
          const y = track["tly"]
          const width = track["brx"] - x
          const height = track["bry"] - y
          const keyPoints = track["keypoints"]

          // Create timestamp object if doesn't exist
          if (formattedOrderTracks[orderTrackTimestamp] == null)
            formattedOrderTracks[orderTrackTimestamp] = {}
          // Create camera object for timestamp if doesn't exist
          if (formattedOrderTracks[orderTrackTimestamp][cameraId] == null) {
            formattedOrderTracks[orderTrackTimestamp][cameraId] = []
          }
          // Create camera order list if doesn't exist
          if (orders[cameraId] == null) orders[cameraId] = []

          // Add order data to formattedOrderTracks
          formattedOrderTracks[orderTrackTimestamp][cameraId].push({
            orderId: orderTrackId,
            x,
            y,
            width,
            height,
            keyPoints,
          })
        }
        // Add order id to camera order list
        if (orderTrackId && !orders[cameraId].includes(orderTrackId))
          orders[cameraId].push(orderTrackId)
      })
    }
  })
  console.log("orders V2 = " + JSON.stringify(orders))
  console.log("formattedOrderTracks V2 = " + JSON.stringify(formattedOrderTracks))

  return { formattedOrderTracks, orders }
}

export { getAndFormatOrderTracks, formatOrderTracksV2 }
